<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="content">
  <div class="heading">{{ data.name }}</div>

  <mat-progress-spinner
    *ngIf="loadingReleaseNotes"
    color="primary"
    mode="indeterminate"
    diameter="50"
  ></mat-progress-spinner>

  <table *ngIf="!loadingReleaseNotes">
    <thead>
      <tr>
        <th>Date</th>
        <th>Feature</th>
        <th>Notes</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rn of releaseNotePage">
        <td>{{ rn.release_date }}</td>
        <td>{{ rn.feature }}</td>
        <td>
          <!-- <a [href]="rn.document" target="_blank"><mat-icon>insert_drive_file</mat-icon></a> -->
          <a (click)="openReleaseNote(rn.document)"><mat-icon>insert_drive_file</mat-icon></a>
        </td>
      </tr>
    </tbody>
  </table>
  <mat-paginator
    *ngIf="!!notes && notes.length > releaseNotePageSize"
    [pageSize]="releaseNotePageSize"
    [length]="notes.length"
    (page)="handleReleaseNotePageEvent($event)"
  >
  </mat-paginator>
  <button mat-raised-button (click)="close()">close</button>
</div>
